import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { replacePathParams } from 'utils/routes.utils';

import { Routes } from 'constants/routes.constants';
import { useCartStore, useCartStoreActions } from 'services/stores/cart';

import ResponsiveDrawerDialog from 'components/@common/ResponsiveDrawerDialog';

const ExpiredDialog = () => {
  const router = useRouter();
  const seatingToken = useCartStore((state) => state.seatingToken);
  const [isLoading, setIsLoading] = useState(false);
  const { removeTicketingCartAndSeats } = useCartStoreActions();

  const handleExpiredCart = () => {
    setIsLoading(true);
    const asPath = router.asPath;
    const pathToGoTo = replacePathParams(Routes.EventCart, {
      slug: router.query.slug as string,
    });
    removeTicketingCartAndSeats();
    if (asPath === pathToGoTo) {
      router.reload();
    } else {
      router.replace(pathToGoTo);
    }
  };

  const openExpiredDialog =
    !!seatingToken && seatingToken.expired && !seatingToken.expirationHandled;

  return (
    <ResponsiveDrawerDialog
      isOpen={openExpiredDialog}
      dialogProps={{ disableEscapeKeyDown: true }}
      // Ensure we are always on top
      stackPriority={1000}
    >
      <DialogTitle>
        <FormattedMessage id="event.seating.expired_dialog.title" />
      </DialogTitle>
      <DialogContent>
        <FormattedMessage id="event.seating.expired_dialog.description" />
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          color="secondary"
          fullWidth
          loading={isLoading}
          onClick={handleExpiredCart}
        >
          <FormattedMessage id="event.seating.expired_dialog.action" />
        </Button>
      </DialogActions>
    </ResponsiveDrawerDialog>
  );
};

export default ExpiredDialog;
